// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wzMaj","icon":"styles_icon__12T2K"};